export default __webpack_public_path__ + "static/preparation-85fa9db7be3345def79af3bd9890e1d1.png";